import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import TnVed from '../components/TnVed/TnVed';
import NavBar from '../components/Main/NavBar';
import MobileNav from '../components/Main/MobileNav';
import SlidingMenu from '../components/Main/SlidingMenu';
import { BACKEND_URL } from '../consts';
import { getProfile } from '../api';


const CargoParams = (props) => {


    function check1Click() {
        props.setCheck1(true);
        props.setCheck2(false);
        props.setCalcOptions('kg_cargo');
    }
    function check2Click() {
        props.setCheck2(true);
        props.setCheck1(false);
        props.setCalcOptions('kg_package');
    }


    // 


    function check3Click() {
        props.setCheck3(true);
        props.setCheck4(false);
        props.setCheck5(false);
        props.setUnit('Мм.')
    }
    function check4Click() {
        props.setCheck4(true);
        props.setCheck3(false);
        props.setCheck5(false);
        props.setUnit('См.')
    }
    function check5Click() {
        props.setCheck5(true);
        props.setCheck4(false);
        props.setCheck3(false);
        props.setUnit('М.')
    }


    // 
    function check6Click() {
        props.setCheck6(true);
        props.setCheck7(false);
        props.setSimilarPackage(true)
    }
    function check7Click() {
        props.setCheck7(true);
        props.setCheck6(false);
        props.setSimilarPackage(false)
    }


    function handleQuantityPackInputChange(event) {
        const value = event.target.value;
        if (/^\d*$/.test(value) && (value === "" || parseFloat(value) >= 1)) {
            props.setQuantityPack(value);
        }
    }

    const handleQuantityPackChange = (increment) => {
        props.setQuantityPack((prev) => {
            const newValue = parseFloat(prev) + increment;
            return newValue < 1 ? 1 : newValue;
        });
    };

    const handlePackWeightInputChange = (event) => {
        const value = event.target.value;
        const regex = /^(\d+([.,]?\d{0,2})?)?$/;
        if (regex.test(value)) {
            props.setPackWeight(value);
        }
    };

    const handlePackWeightChange = (increment) => {
        const newValue = parseFloat(props.PackWeight.replace(',', '.')) || 0;
        const updatedValue = newValue + increment;
        if (updatedValue >= 0) {
            props.setPackWeight(updatedValue.toFixed(2).toString().replace(',', '.'));
        }
    };


    return (
        <>
            <div className='flex flex-row gap-2 p-2'>
                <div onClick={check1Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                    <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check1 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                        {props.check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                    </div>

                    <span className='text-[16px]'>{props.title1}</span>
                </div>

                <div onClick={check2Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                    <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check2 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                        {props.check2 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                    </div>

                    <span className='text-[16px]'>{props.title2}</span>
                </div>
            </div>
            {
                props.alBl && <AlertBlock title={'Если Вы не знаете сколько весит отдельная упаковка, Вы можете указать вес груза в целом и мы сделаем расчет на основе этого параметра'} />
            }


            <div className={` ${props.check2 ? 'block' : 'hidden'}`}>


                <div className='sm:flex-row flex flex-col gap-[8px]'>
                    <div className='w-full sm:w-[49%] mb-[8px]'>
                        <div className='flex items-center w-[100%]  border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                            <div className='w-[100%] p-[11px] sm:p-[15px]'>
                                <div className='flex items-center justify-between text-[13px] text-[#626C75]'>
                                    <span>Вес</span>
                                    <span>кг/упаковка</span>
                                </div>
                                <div className='w-[100%]'>
                                    <input
                                        className='w-[100%] text-[#1F2225] outline-none'
                                        value={props.PackWeight}
                                        onChange={handlePackWeightInputChange}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                                <button
                                    className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                    onClick={() => handlePackWeightChange(0.01)} >
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white" />
                                    </svg>
                                </button>
                                <button
                                    className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                    onClick={() => handlePackWeightChange(-0.01)}>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='w-full sm:w-[49%] mb-[8px]'>
                        <div className='flex items-center w-[100%]  border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                            <div className='w-[100%] p-[11px] sm:p-[15px]'>
                                <div className='flex items-center justify-between text-[13px] text-[#626C75]'>
                                    <span>Кол-во упаковок</span>
                                    <span>шт.</span>
                                </div>
                                <div className='w-[100%]'>
                                    <input
                                        className='w-[100%] text-[#1F2225] outline-none'
                                        value={props.quantityPack}
                                        onChange={handleQuantityPackInputChange}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                                <button
                                    className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                    onClick={() => handleQuantityPackChange(1)} >
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white" />
                                    </svg>
                                </button>
                                <button
                                    className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                    onClick={() => handleQuantityPackChange(-1)}>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='grid grid-cols-2 mt-4 w-full'>
                    <div className='flex flex-col gap-2'>
                        <span className='text-[#626C75] text-[17px]'>Единицы измерения</span>

                        <div onClick={check3Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                            <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check3 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                                {props.check3 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                            </div>

                            <span className='text-[16px]'>Миллимитры</span>
                        </div>
                        <div onClick={check4Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                            <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check4 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                                {props.check4 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                            </div>

                            <span className='text-[16px]'>Сантиметры</span>
                        </div>
                        <div onClick={check5Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                            <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check5 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                                {props.check5 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                            </div>

                            <span className='text-[16px]'>Метры</span>
                        </div>

                    </div>

                    <div>
                        <img src='./box.svg' />
                    </div>

                </div>
                <span className='text-[#626C75] text-[17px]'>Параметры упаковок</span>
                <div className='flex flex-row mt-2 gap-2'>

                    <div onClick={check6Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check6 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                            {props.check6 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[16px]'>Одинаковые</span>
                    </div>

                    <div onClick={check7Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.check7 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                            {props.check7 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[16px]'>Разные</span>
                    </div>

                </div>
                <Packaging
                    similar={props.check6}
                    different={props.check7}
                    unit={props.unit}
                    setPackages={props.setPackages}
                    quantityPack={props.quantityPack}
                    setQuantityPack={props.setQuantityPack}
                    PackWidth={props.PackWidth}
                    setPackWidth={props.setPackWidth}
                    PackHeight={props.PackHeight}
                    setPackHeight={props.setPackHeight}
                    PackLength={props.PackLength}
                    setPackLength={props.setPackLength}
                    PackVolume={props.PackVolume}
                    setPackVolume={props.setPackVolume}
                    PackDensity={props.PackDensity}
                    setPackDensity={props.setPackDensity}
                    setTotalVolume={props.setTotalVolume}
                    totalDensity={props.totalDensity}
                    setTotalDensity={props.setTotalDensity}
                    PackWeight={props.PackWeight}
                    check3={props.check3}
                    setCheck3={props.setCheck3}
                    check4={props.check4}
                    setCheck4={props.setCheck4}
                    check5={props.check5}
                    setCheck5={props.setCheck5}
                />
            </div>

            {/*  */}
            <div className={`w-[100%] ${props.check1 ? 'block' : 'hidden'} mt-[24px] gap-[5px]`}>
                <div className='w-[100%] mb-[8px]'>
                    <div className='flex items-center w-[100%]  border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                        <div className='w-[100%] p-[11px] sm:p-[15px]'>
                            <div className='flex items-center justify-between text-[14px] text-[#626C75]'>
                                <span>Вес</span>
                                <span>кг.</span>
                            </div>
                            <div className='w-[100%]'>
                                <input
                                    className='w-[100%] text-[#1F2225] outline-none'
                                    value={props.weight}
                                    onChange={props.handleWeightInputChange}
                                />
                            </div>
                        </div>
                        <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => props.handleWeightChange(0.01)} >
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white" />
                                </svg>
                            </button>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => props.handleWeightChange(-0.01)}>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className='w-[100%] flex-col sm:flex-row flex gap-[8px]'>
                    <div className='w-[100%] sm:w-[49%] border-[1px] border-solid border-[#C9CED2] rounded-[16px] p-[15px]'>
                        <div className='flex items-center justify-between text-[#626C75] text-[14px]'>
                            <div>Объем</div>
                            <div>куб.м</div>
                        </div>
                        <input value={props.volume} onChange={props.handleVolumeChange} />
                    </div>
                    <div className='w-[100%] sm:w-[49%] border-[1px] border-solid border-[#C9CED2] rounded-[16px] p-[15px]'>
                        <div className='flex items-center justify-between text-[#626C75] text-[14px]'>
                            <div>Плотность</div>
                            <div>кг/куб.м</div>
                        </div>
                        <input value={props.density}
                            onChange={props.handleDensityInputChange} />
                    </div>
                </div>

            </div>
        </>
    )

}




const SetCheckBox = ({ title, btns, all, del, onSelectionChange }) => {
    const [selectedIndexes, setSelectedIndexes] = useState([]);

    const handleSelect = (index) => {
        if (selectedIndexes.includes(index)) {
            const newIndexes = selectedIndexes.filter(i => i !== index);
            setSelectedIndexes(newIndexes);
            onSelectionChange(newIndexes.map(i => btns[i]));
        } else {
            const newIndexes = [...selectedIndexes, index];
            setSelectedIndexes(newIndexes);
            onSelectionChange(newIndexes.map(i => btns[i]));
        }
    };

    const handleSelectAll = () => {
        const allIndexes = btns.map((_, index) => index);
        setSelectedIndexes(allIndexes);
        onSelectionChange(btns);
    };

    const handleDeselectAll = () => {
        setSelectedIndexes([]);
        onSelectionChange([]);
    };

    return (
        <div className='flex flex-col'>
            <span className='text-[20px] sm:text-[24px] my-2'>{title}</span>
            {btns.map((btn, index) => (
                <div key={index} className='cursor-pointer p-[6px] flex flex-row w-fit gap-2 items-center pr-[8px]' onClick={() => handleSelect(index)}>
                    <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${selectedIndexes.includes(index) ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                        {selectedIndexes.includes(index) && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                    </div>
                    <span className='text-[16px]'>{btn}</span>
                </div>
            ))}

            <div className='flex flex-row mt-2 gap-2'>
                {all && (
                    <button onClick={handleSelectAll} className={`p-[6px] flex flex-row w-fit rounded-full ${selectedIndexes.length === btns.length ? "bg-white text-black" : "bg-black text-white"} border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]`}>
                        <div style={{ aspectRatio: 1 }} className={`flex items-center justify-center h-[20px] rounded-full`}>
                            <img className='w-[90%] h-[90%]' src={selectedIndexes.length === btns.length ? './acces-gray.png' : './checkImg.png'} alt="checkImg" />
                        </div>
                        <span className={`text-[14px] sm:text-[16px] ${selectedIndexes.length === btns.length ? "text-[#626C75]" : "text-[#FFF]"}`}>{all}</span>
                    </button>
                )}
                {del && (
                    <button onClick={handleDeselectAll} className='p-[6px] flex flex-row w-fit border-[#C9CED2] border-[1px] rounded-full gap-2 items-center pr-[8px]'>
                        <div style={{ aspectRatio: 1 }} className={`flex items-center justify-center h-[20px] rounded-full`}>
                            <img className='w-[80%] h-[80%]' src='./cross-black.png' alt="Checked" />
                        </div>
                        <span className='text-[14px] sm:text-[16px]'>{del}</span>
                    </button>
                )}
            </div>
        </div>
    );
};



const AlertBlock = ({ title }) => {
    const [check1, setCheck1] = useState(false)
    return (
        <div className='w-full my-2 p-2 bg-[#EFF0F2] flex flex-row gap-2 rounded-xl'>
            <img style={{ aspectRatio: 1 }} className=' w-[16px] h-[16px]' src='./info.png' />
            <span className='text-[#626C75] text-[12px]'>{title}</span>
        </div>
    )

}




const Packaging = ({ similar, different, unit, setPackages, quantityPack, setQuantityPack, PackWidth, setPackWidth, PackHeight, setPackHeight, PackLength, setPackLength, PackVolume, setPackVolume, PackDensity, setPackDensity, setTotalVolume, totalDensity, setTotalDensity, PackWeight, check3, setCheck3, check4, setCheck4, check5, setCheck5 }) => {

    const [packagingList, setPackagingList] = useState([]);

    setPackVolume(
        check3
            ? (parseFloat((PackWidth * 0.001 * PackHeight * 0.001 * PackLength * 0.001).toFixed(3)) || 0)
            : check4
                ? (parseFloat((PackWidth * 0.01 * PackHeight * 0.01 * PackLength * 0.01).toFixed(3)) || 0)
                : check5
                    ? (parseFloat((PackWidth * PackHeight * PackLength).toFixed(3)) || 0)
                    : (parseFloat((PackWidth * 0.01 * PackHeight * 0.01 * PackLength * 0.01).toFixed(3)) || 0)
    );

    if (PackVolume > 0 && !isNaN(PackWidth)) {
        setPackDensity(
            (PackWeight / PackVolume).toFixed(5)
        );
    } else {
        setPackDensity(0);
    }

    const calculateVolume = (width, height, length) => {
        return check3 ?
            parseFloat(width * 0.001) * parseFloat(height * 0.001) * parseFloat(length * 0.001) || 0
            : check4 ?
                parseFloat(width * 0.01) * parseFloat(height * 0.01) * parseFloat(length * 0.01) || 0
                : check5 ?
                    parseFloat(width) * parseFloat(height) * parseFloat(length) || 0
                    : parseFloat(width * 0.01) * parseFloat(height * 0.01) * parseFloat(length * 0.01) || 0;
    };





    const calculateDensity = (weight, volume) => {
        return (parseFloat(weight) || 0) / (parseFloat(volume) || 1);
    };

    useEffect(() => {
        setPackagingList((prevList) => {
            // Если список пустой, инициализируем его
            if (prevList.length === 0) {
                return Array.from({ length: quantityPack }, (_, index) => ({
                    id: Date.now() + index,
                    width: '',
                    height: '',
                    length: '',
                    volume: '',
                    density: '',
                }));
            }

            // Если добавились упаковки, расширяем список
            if (quantityPack > prevList.length) {
                const additionalPackaging = Array.from(
                    { length: quantityPack - prevList.length },
                    (_, index) => ({
                        id: Date.now() + index,
                        width: '',
                        height: '',
                        length: '',
                        volume: '',
                        density: '',
                    })
                );
                return [...prevList, ...additionalPackaging];
            }

            return prevList; // Ничего не меняем, если количество упаковок не изменилось
        });
    }, [quantityPack]);

    const handleInputChange1 = (setter) => (event) => {
        const value = event.target.value;
        const regex = /^\d*([.,]?\d{0,2})?$/;
        if (regex.test(value)) {
            setter(value);
        }
    };

    const handleInputChange = (id, field) => (event) => {
        const value = event.target.value;
        const regex = /^\d*([.,]?\d{0,2})?$/;

        if (regex.test(value)) {
            setPackagingList(packagingList.map(packaging => {
                if (packaging.id === id) {
                    const updatedPackaging = { ...packaging, [field]: value };
                    if (field === 'width' || field === 'height' || field === 'length') {
                        updatedPackaging.volume = calculateVolume(updatedPackaging.width, updatedPackaging.height, updatedPackaging.length);
                        updatedPackaging.density = (calculateDensity(PackWeight, updatedPackaging.volume));
                    }
                    return updatedPackaging;
                }
                return packaging;
            }));
        }
    };

    const addPackaging = () => {
        const newPackaging = {
            id: Date.now(),
            width: '',
            height: '',
            length: '',
            volume: '',
            density: ''
        };

        setPackagingList((prevList) => [...prevList, newPackaging]); // Добавляем новую упаковку
    };

    const removePackaging = (id) => {
        setPackagingList(packagingList.filter(packaging => packaging.id !== id)); // Удаляем упаковку по id
        setQuantityPack(prev => Math.max(prev - 1, 1)); // Уменьшаем количество упаковок, не позволяя ему опуститься ниже 1
    };

    useEffect(() => {
        const newPackages = [];

        // Если есть одна упаковка
        if (similar && PackWidth && PackHeight && PackLength && PackDensity) {
            const volume = calculateVolume(PackWidth, PackHeight, PackLength);
            newPackages.push({
                num: 1,
                length: PackLength,
                width: PackWidth,
                height: PackHeight,
                volume: volume,
                thikness: PackDensity,
            });
        }

        // Если есть несколько упаковок
        if (different) {
            const packagedItems = packagingList.map(packaging => ({
                num: packaging.id,
                length: packaging.length,
                width: packaging.width,
                height: packaging.height,
                volume: packaging.volume,
                thikness: packaging.density,
            }));
            newPackages.push(...packagedItems);
        }

        setPackages(newPackages);
    }, [PackWidth, PackHeight, PackLength, PackDensity, setPackages, packagingList, similar, different]);

    // Вычисление общего объема упаковок
    useEffect(() => {
        const calculatedTotalVolume = packagingList.reduce((total, packaging) => {
            const volume = parseFloat(packaging.volume) || 0; // Получаем значение объема
            return total + volume; // Суммируем объемы
        }, 0);

        // Если есть одна упаковка, добавляем ее объем
        if (similar && PackWidth && PackHeight && PackLength) {
            const singleVolume = calculateVolume(PackWidth, PackHeight, PackLength);
            setTotalVolume(calculatedTotalVolume + singleVolume);
        } else {
            setTotalVolume(calculatedTotalVolume);
        }
    }, [packagingList, PackWidth, PackHeight, PackLength, similar, setTotalVolume]);


    // НЕ УДАЛЯТЬ НИ В КОЕМ СЛУЧАЕ, ИНАЧЕ КОНСОЛИ ПИЗЛДЕЦ, БУДУТ БЕСКОНЕЧНЫЕ ПИЗДА
    useEffect(() => {
        setPackagingList((prevList) =>
            prevList.map((packaging) => {
                if (!packaging.width || !packaging.height || !packaging.length) return packaging; // Если данные отсутствуют, не изменяем
                const volume = calculateVolume(packaging.width, packaging.height, packaging.length);
                const density = calculateDensity(PackWeight, volume);
                return { ...packaging, volume, density };
            })
        );
    }, [PackWeight, check3, check4, check5]);


    return (
        <>
            <div className={`${similar ? 'block' : 'hidden'} p-4 mt-4 bg-[#EFF0F2] rounded-2xl`}>
                <div className='flex flex-row gap-2 items-center'>
                    <img style={{ aspectRatio: 1 }} src='./packaking.png' className='w-[24px] h-[24px]' />
                    <span className='text-[24px]'>Упаковки </span>
                </div>

                <div className='flex mt-4 flex-wrap sm:flex-row flex-col'>
                    <div className={`py-2 px-4 m-auto w-[100%] sm:w-[32%] flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                        <div className='flex w-[100%] flex-col'>
                            <div className='w-full flex flex-row justify-between'>
                                <span className='text-[14px] text-[#626C75]'>Ширина</span>
                                <span className='text-[14px] text-[#626C75]'>{unit}</span>
                            </div>
                            <input className='w-full' type="text" placeholder="0" value={PackWidth} onChange={handleInputChange1(setPackWidth)} />
                        </div>
                    </div>

                    <div className={`py-2 px-4 w-[100%] sm:w-[32%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                        <div className='flex w-[100%] flex-col'>
                            <div className='w-full flex flex-row justify-between'>
                                <span className='text-[14px] text-[#626C75]'>Высота</span>
                                <span className='text-[14px] text-[#626C75]'>{unit}</span>
                            </div>
                            <input className='w-full' type="text" placeholder="0" value={PackHeight} onChange={handleInputChange1(setPackHeight)} />
                        </div>
                    </div>

                    <div className={`py-2 px-4 w-[100%] sm:w-[32%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                        <div className='flex w-[100%] flex-col'>
                            <div className='w-full flex flex-row justify-between'>
                                <span className='text-[14px] text-[#626C75]'>Длина</span>
                                <span className='text-[14px] text-[#626C75]'>{unit}</span>
                            </div>
                            <input className='w-full' type="text" placeholder="0" value={PackLength} onChange={handleInputChange1(setPackLength)} />
                        </div>
                    </div>

                    <div className={`py-2 px-4 w-[100%] sm:w-[49%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                        <div className='flex w-[100%] flex-col'>
                            <div className='w-full flex flex-row justify-between'>
                                <span className='text-[14px] text-[#626C75]'>Объем</span>
                                <span className='text-[14px] text-[#626C75]'>куб.м</span>
                            </div>
                            <input className='w-full' type="text" placeholder="0" value={PackVolume || ''} />
                        </div>
                    </div>

                    <div className={`py-2 px-4 w-[100%] sm:w-[49%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                        <div className='flex w-[100%] flex-col'>
                            <div className='w-full flex flex-row justify-between'>
                                <span className='text-[14px] text-[#626C75]'>Плотность</span>
                                <span className='text-[14px] text-[#626C75]'>кг./куб.м</span>
                            </div>
                            <input className='w-full' type="text" placeholder="0" value={PackDensity || ''} />
                        </div>
                    </div>
                </div>
            </div>


            <div className={`${different ? 'block' : 'hidden'} mt-4`}>
                {packagingList.map((packaging) => (
                    <div key={packaging.id} id='card' className={`p-4 mb-[5px] bg-[#EFF0F2] rounded-2xl`}>
                        <div className='flex flex-row gap-2 items-center justify-between'>
                            <div className='flex flex-row gap-2 items-center'>
                                <img style={{ aspectRatio: 1 }} src='./packaking.png' className='w-[24px] h-[24px]' />
                                <span className='text-[24px]'>Упаковки </span>
                            </div>
                            <div>
                                <button onClick={() => removePackaging(packaging.id)} id='del'>
                                    <img src='./calcDelCard.svg' />
                                </button>
                            </div>
                        </div>

                        <div className='flex mt-4 flex-wrap sm:flex-row flex-col'>
                            <div className={`py-2 px-4 m-auto w-[100%] sm:w-[32%] flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex w-[100%] flex-col'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Ширина</span>
                                        <span className='text-[14px] text-[#626C75]'>{unit}</span>
                                    </div>
                                    <input className='w-full' type="text" placeholder="0" value={packaging.width} onChange={handleInputChange(packaging.id, 'width')} />
                                </div>
                            </div>

                            <div className={`py-2 px-4 w-[100%] sm:w-[32%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex w-[100%] flex-col'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Высота</span>
                                        <span className='text-[14px] text-[#626C75]'>{unit}</span>
                                    </div>
                                    <input className='w-full' type="text" placeholder="0" value={packaging.height} onChange={handleInputChange(packaging.id, 'height')} />
                                </div>
                            </div>

                            <div className={`py-2 px-4 w-[100%] sm:w-[32%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex w-[100%] flex-col'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Длина</span>
                                        <span className='text-[14px] text-[#626C75]'>{unit}</span>
                                    </div>
                                    <input className='w-full' type="text" placeholder="0" value={packaging.length} onChange={handleInputChange(packaging.id, 'length')} />
                                </div>
                            </div>

                            <div className={`py-2 px-4 w-[100%] sm:w-[49%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex w-[100%] flex-col'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Объем</span>
                                        <span className='text-[14px] text-[#626C75]'>куб.м</span>
                                    </div>
                                    <input className='w-full' type="text" placeholder="0" onChange={handleInputChange} value={packaging.volume} />
                                </div>
                            </div>

                            <div className={`py-2 px-4 w-[100%] sm:w-[49%] m-auto flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex w-[100%] flex-col'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Плотность</span>
                                        <span className='text-[14px] text-[#626C75]'>кг./куб.м</span>
                                    </div>
                                    <input className='w-full' type="text" placeholder="0" onChange={handleInputChange} value={packaging.density} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                <div id='add' className='mt-[8px] cursor-pointer text-[#fff] text-[17px] sm:text-[20px] flex items-center justify-between sm:py-[16px] py-[12px] px-[16px] sm:px-[32px] bg-[#1F2225] hover:bg-[#313438] duration-300 rounded-[30px]' onClick={addPackaging}>
                    <div>Добавить ещё упаковку</div>
                    <img src='./Add.svg' />
                </div>
            </div>
        </>
    )
}

const Condition = (props) => {

    const [check1, setCheck1] = useState(false)
    const [check2, setCheck2] = useState(false)
    const [check3, setCheck3] = useState(false)
    const [check4, setCheck4] = useState(false)

    function onClick1() {
        setCheck1(true)
        setCheck2(false)
        setCheck3(false)
        setCheck4(false)
        props.setDealCondition('customers_terms')
    }
    function onClick2() {
        setCheck2(true)
        setCheck3(false)
        setCheck4(false)
        setCheck1(false)
        props.setDealCondition('need_terms')
    }
    function onClick3() {
        setCheck3(true)
        setCheck4(false)
        setCheck1(false)
        setCheck2(false)
        props.setDealCondition('no_terms')
    }
    function onClick4() {
        setCheck4(true)
        setCheck1(false)
        setCheck2(false)
        setCheck3(false)
        props.setDealCondition('cargo_terms')
    }


    return (
        <div className='w-full flex gap-3 flex-col'>
            <div onClick={onClick1} className={`cursor-pointer py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                <div className='flex flex-col'>
                    <span className='text-[12px] sm:text-[14px] text-[#626C75]'>Свой контракт</span>
                    <span className='text-[14px] sm:text-[16px]'>У меня свой внешнеторговый контракт</span>
                </div>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>
            </div>

            <div onClick={onClick2} className={`cursor-pointer py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                <div className='flex flex-col'>
                    <span className='text-[12px] sm:text-[14px] text-[#626C75]'>Оформление контракта</span>
                    <span className='text-[14px] sm:text-[16px]'>Требуется оформление контракта</span>
                </div>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check2 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>
            </div>

            <div onClick={onClick3} className={`cursor-pointer py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                <div className='flex flex-col'>
                    <span className='text-[12px] sm:text-[14px] text-[#626C75]'>Договор поставки</span>
                    <span className='text-[14px] sm:text-[16px]'>Контракт не нужен. Хочу получить товар по договору поставки оформление контракта</span>
                </div>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check3 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check3 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>
            </div>
            <div onClick={onClick4} className={`cursor-pointer py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                <div className='flex flex-col'>
                    <span className='text-[12px] sm:text-[14px] text-[#626C75]'>Условия карго</span>
                    <span className='text-[14px] sm:text-[16px]'>Хочу получить груз по условиям “карго”</span>
                </div>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check4 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check4 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>
            </div>
        </div>
    );
};



const OnPalets = (props) => {

    function clickOnPalets() {
        props.setOnPalets(!props.onPalets)
    }

    const inputTypePalets = (event) => {
        props.setTypePalets(event.target.value);
    }

    return (
        <>
            <span className='text-[24px] mt-2'>Палеты</span>

            <div className='flex flex-wrap gap-2'>
                <div onClick={clickOnPalets} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                    <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${props.onPalets ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                        {props.onPalets && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                    </div>

                    <span className='text-[16px]'>На палетах</span>
                </div>

                <div onClick={clickOnPalets} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                    <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${!props.onPalets ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                        {!props.onPalets && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                    </div>

                    <span className='text-[16px]'>Нет</span>
                </div>
            </div>

            <div className={`${props.onPalets ? 'block' : 'hidden'}`}>
                <div className='flex items-center justify-between w-full border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                    <div className='p-[11px] sm:p-[15px]'>
                        <div className='flex items-center justify-between w-full text-[14px] text-[#626C75]'>
                            <span>Кол-во палет</span>
                            <span>шт.</span>
                        </div>
                        <div>
                            <input
                                className='w-full text-[#1F2225] outline-none'
                                value={props.palets}
                                onChange={props.handlePaletsInputChange}
                            />
                        </div>
                    </div>
                    <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                        <button
                            className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                            onClick={() => props.handlePaletsChange(1)} >
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white" />
                            </svg>
                        </button>
                        <button
                            className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                            onClick={() => props.handlePaletsChange(-1)}>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div className='flex flex-row gap-2'>
                    <CkeckBoxPalets title1={'Штабелируемый'} title2={'Нештабелируемый'} setStackable={props.setStackable} setStackableText={props.setStackableText} />
                </div>


                <div className={`py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                    <div className='flex flex-col'>
                        <span className='text-[14px] text-[#626C75]'>Виды палет </span>
                        <input
                            type="text"
                            value={props.typePalets}
                            onChange={inputTypePalets}
                        />
                    </div>
                    <span className={`rounded-full text-[14px]  py-1 px-2 text-white bg-[#C3372E] hover:bg-[#E0473F]`}>Подобрать</span>
                </div>
            </div>

        </>
    )
}


const CkeckBoxPalets = (props) => {
    const [check1, setCheck1] = useState(true)
    const [check2, setCheck2] = useState(false)

    function check1Click() {
        setCheck1(true);
        setCheck2(false);
    }
    function check2Click() {
        setCheck2(true);
        setCheck1(false);
    }
    if (check1) {
        props.setStackable(true)
        props.setStackableText('Штабелируемый')
    }
    if (check2) {
        props.setStackable(false)
        props.setStackableText('Нештабелируемый')
    }
    return (
        <div className='flex flex-wrap gap-2 p-2'>
            <div onClick={check1Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>

                <span className='text-[16px]'>{props.title1}</span>
            </div>

            <div onClick={check2Click} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-[#C9CED2] border-[1px] border-1px gap-2 items-center pr-[8px]'>
                <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                    {check2 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                </div>

                <span className='text-[16px]'>{props.title2}</span>
            </div>
        </div>
    )
}





const Calculator = ({ authorized, setAuthorized }) => {
    const [Tnved, setTnved] = useState(false);

    const TnvedOpen = () => {
        setTnved(prev => !prev);
    };



    const [alBl, setAlBl] = useState(false)

    function clickAlBl() {
        setAlBl(!alBl)
    }

    const [PAGE, SET_PAGE] = useState(1);
    const [selectedCountries, setSelectedCountries] = useState(['Китай', 'Россия']);
    const [selectedCities, setSelectedCities] = useState(['Пекин', 'Москва']);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [showAllCities, setShowAllCities] = useState([false, false]);
    const [invoice, setInvoice] = useState([]);
    const [unit, setUnit] = useState('См');
    const [CalcOptions, setCalcOptions] = useState();
    const [similarPackage, setSimilarPackage] = useState();
    const [packages, setPackages] = useState([]);
    const [selectedCondition, setSelectedCondition] = useState(null);

    const [onPalets, setOnPalets] = useState(false)

    const [codeProduct, setCodeProduct] = useState('');
    const handleInputChangeCode = (event) => {
        const value = event.target.value;
        const regex = /^[0-9]*$/;
        if (regex.test(value)) {
            setCodeProduct(value);
        }
    };


    const [invoicePrice, setInvoicePrice] = useState("");
    const handleInputChangePrice = (event) => {
        const value = event.target.value;
        const regex = /^\d*\.?\d{0,2}$/;
        if (regex.test(value)) {
            setInvoicePrice(value);
        }
    };



    const [dealCondition, setDealCondition] = useState('');

    const [PackWidth, setPackWidth] = useState('');
    const [PackHeight, setPackHeight] = useState('');
    const [PackLength, setPackLength] = useState('');
    const [PackVolume, setPackVolume] = useState('');
    const [PackDensity, setPackDensity] = useState('');
    const [totalVolume, setTotalVolume] = useState(0);
    const [PackWeight, setPackWeight] = useState('100');

    const [totalDensity, setTotalDensity] = useState(0)


    const [quantityPack, setQuantityPack] = useState(1);


    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState([]);

    // Новые переменные для хранения ответов на английском
    const [selectedServicesEn, setSelectedServicesEn] = useState([]);
    const [selectedSuppliersEn, setSelectedSuppliersEn] = useState([]);
    const [selectedPaymentEn, setSelectedPaymentEn] = useState([]);

    const servicesTranslation = {
        "Таможенное декларирование": "customs_declaration",
        "Сертификация товара": "product_certification",
        "Честный знак": "honest_sign"
    };

    const suppliersTranslation = {
        "Поиск товара по фото или ссылке": "photo",
        "Подбор и переговоры с поставщиком": "communication"
    };

    const paymentTranslation = {
        "Оплата со счёта компании": "company",
        "Оплата наличными": "cash"
    };

    const handleServicesSelectionChange = (selection) => {
        setSelectedServices(selection);
        setSelectedServicesEn(selection.map(service => servicesTranslation[service] || service));
    };

    const handleSuppliersSelectionChange = (selection) => {
        setSelectedSuppliers(selection);
        setSelectedSuppliersEn(selection.map(supplier => suppliersTranslation[supplier] || supplier));
    };

    const handlePaymentSelectionChange = (selection) => {
        setSelectedPayment(selection);
        setSelectedPaymentEn(selection.map(payment => paymentTranslation[payment] || payment));
    };




    const [check1, setCheck1] = useState(true)
    const [check2, setCheck2] = useState(false)

    const [check3, setCheck3] = useState(false)
    const [check4, setCheck4] = useState(false)
    const [check5, setCheck5] = useState(false)

    const [check6, setCheck6] = useState(false)
    const [check7, setCheck7] = useState(false)



    const countries = [
        'Китай',
        'Россия',
    ];

    const cities = {
        'Китай': ['Гуанчжоу',],
        'Россия': ['Москва',],
    };

    useEffect(() => {
        const savedCities = localStorage.getItem('selectedCities');
        if (savedCities) {
            setSelectedCities(JSON.parse(savedCities));
        }
    }, []);

    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };

    const selectCountry = (country, index) => {
        const newCountries = [...selectedCountries];
        newCountries[index] = country;
        setSelectedCountries(newCountries);

        setSelectedCities((prevCities) => {
            const newCities = [...prevCities];
            newCities[index] = '';
            return newCities;
        });

        setShowAllCities((prev) => {
            const newState = [...prev];
            newState[index] = false;
            return newState;
        });

        localStorage.setItem('selectedCountries', JSON.stringify(newCountries));
    };

    const selectCity = (city, index) => {
        const newCities = [...selectedCities];
        newCities[index] = city;
        setSelectedCities(newCities);
        setOpenDropdownIndex(null);

        localStorage.setItem('selectedCities', JSON.stringify(newCities));
    };

    const swapCountries = () => {
        const swappedCountries = [selectedCountries[1], selectedCountries[0]];
        const swappedCities = [selectedCities[1], selectedCities[0]];

        setSelectedCountries(swappedCountries);
        setSelectedCities(swappedCities);

        localStorage.setItem('selectedCountries', JSON.stringify(swappedCountries));
        localStorage.setItem('selectedCities', JSON.stringify(swappedCities));
    };

    const toggleShowAllCities = (index) => {
        setShowAllCities((prev) => {
            const newState = [...prev];
            newState[index] = !newState[index];
            return newState;
        });
    };







    // кнопки с типом достаки
    const buttons = [
        { label: 'Авто', value: 'auto', greyImg: "/img/calkulator/carGrey.svg", activeImg: "/img/calkulator/carActive.svg" },
        { label: 'Авиа', value: 'avia', greyImg: "/img/calkulator/samoletikGrey.svg", activeImg: "/img/calkulator/samoletikActive.svg" },
        // { label: 'ЖД', value: 'train', greyImg: "/img/calkulator/poezdGrey.svg", activeImg: "/img/calkulator/poezdActive.svg" },
        { label: 'Морем', value: 'ship', greyImg: "/img/calkulator/corablickGrey.svg", activeImg: "/img/calkulator/corablickActive.svg" },
    ];

    const [activeButton, setActiveButton] = useState(buttons[0].value);
    const [hoveredButton, setHoveredButton] = useState(null);
    const [activeButtonIndex, setActiveButtonIndex] = useState(0);


    useEffect(() => {
        const savedButton = localStorage.getItem('delivery_type');
        if (savedButton) {
            setActiveButton(savedButton);
        }
    }, []);


    useEffect(() => {
        const index = buttons.findIndex(button => button.value === activeButton);
        setActiveButtonIndex(index);
    }, [activeButton]);

    const activeDelivery = buttons.find(button => button.value === activeButton);
    const deliveryImage = activeDelivery ? activeDelivery.activeImg : '';
    const deliveryText = activeDelivery ? activeDelivery.label : '';

    const handleButtonClick = (value) => {
        setActiveButton(value);
        localStorage.setItem('delivery_type', value);
    };

    const deliviry_type_translater = {
        "1": "auto",
        "2": "avia",
        // "3": "train",
        // "4": "ship",
        "3": "ship",
    }



    // Поля вес и обьём

    const [weight, setWeight] = useState(() => {
        const savedWeight = localStorage.getItem('weight');
        return savedWeight ? savedWeight : '0'; // Убедитесь, что возвращаете строку
    });

    const [volume, setVolume] = useState(() => {
        const savedVolume = localStorage.getItem('volume');
        return savedVolume ? savedVolume : '0'; // Убедитесь, что возвращаете строку
    });

    const regex = /^(\d+([.,]?\d{0,2})?)?$/;

    const handleWeightChange = (increment) => {
        const newValue = parseFloat(weight.replace(',', '.')) || 0;
        const updatedValue = newValue + increment;

        if (updatedValue >= 0) {
            setWeight(updatedValue.toFixed(2).toString().replace(',', '.'));
            localStorage.setItem('weight', updatedValue.toFixed(2).toString().replace(',', '.')); // Сохранение в localStorage
        }
    };

    const handleWeightInputChange = (e) => {
        const inputValue = e.target.value;
        if (regex.test(inputValue)) {
            setWeight(inputValue);
            localStorage.setItem('weight', inputValue); // Сохранение в localStorage
        }
    };

    const handleVolumeChange = (e) => {
        const inputValue = e.target.value;
        if (regex.test(inputValue)) {
            setVolume(inputValue);
            localStorage.setItem('volume', inputValue); // Сохранение в localStorage
        }
    };

    const [density, setDensity] = useState('0');
    const handleDensityInputChange = (e) => {
        const inputValue = e.target.value;
        if (regex.test(inputValue)) {
            setDensity(inputValue);
        }
    };

    useEffect(() => {
        const numericWeight = parseFloat(weight.replace(',', '.')) || 0;
        const numericVolume = parseFloat(volume.replace(',', '.')) || 0;

        if (numericVolume > 0) {
            setDensity((numericWeight / numericVolume).toFixed(2).toString().replace(',', '.'));
        } else {
            setDensity('0');
        }
    }, [weight, volume]);




    //поля с выбором типа груза
    const [isOpen, setIsOpen] = useState(false);
    const [selectedType, setSelectedType] = useState('');
    const [selectedTypeEnglish, setSelectedTypeEnglish] = useState('');

    const cargoTypes = [
        'Одежда',
        'Обувь',
        'Товары народного потребления',
        'Автозапчасти',
        'Хоз товары',
    ];

    const cargo_type_translater = {
        'Одежда': "clothes",
        'Обувь': "shoes",
        'Товары народного потребления': "consumer",
        'Автозапчасти': "autoparts",
        'Хоз товары': "household",
    };

    useEffect(() => {
        const storedType = localStorage.getItem('cargo_type');
        if (storedType) {
            setSelectedType(storedType);
            setSelectedTypeEnglish(cargo_type_translater[storedType]);
        }
    }, []);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSelectType = (type) => {
        setSelectedType(type);
        setSelectedTypeEnglish(cargo_type_translater[type]);
        localStorage.setItem('cargo_type', type);
        setIsOpen(false);
    };

    const handleReset = () => {
        setSelectedType('');
        setSelectedTypeEnglish('');
        localStorage.removeItem('cargo_type');
        setIsOpen(false);
    };








    // 
    const [adress, setAdress] = useState('');

    const handleAddressInputChange = (event) => {
        const value = event.target.value;
        setAdress(value);
    }


    // 
    const [palets, setPalets] = useState(5);
    const handlePaletsChange = (increment) => {
        setPalets((prev) => parseFloat((prev + increment).toFixed(2)));
    };
    const handlePaletsInputChange = (event) => {
        const value = event.target.value;
        const regex = /^\d*\.?\d{0,2}$/;
        if (regex.test(value)) {
            setPalets(value);
        }
    };

    // 
    const [stackable, setStackable] = useState();
    const [stackableText, setStackableText] = useState('');
    const [typePalets, setTypePalets] = useState('');



    // ФИО ПОЧТА НОМЕР ТЕЛЕФОНА НАЗВАНИЕ КОМПАНИЯ

    const [fullName, setFullName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const handleInputChange = (setter) => (event) => {
        setter(event.target.value);
    };


    // 
    const [cost, setCost] = useState("-");
    const [time, setTime] = useState("-");
    const [timeRange, setTimeRange] = useState("0-0");
    const [hasCalculated, setHasCalculated] = useState(false);

    const Calculate = async (delivery, cargo, w, v) => {
        setCost("-");
        setTime("-");

        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/calculator/precalculate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "volume": v,
                    "weight": w,
                    "cargo_type": cargo,
                    "delivery_type": delivery
                })
            });


            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const fetchData = await response.json();
            setCost(fetchData.price);
            setTime(fetchData.display_time);
            setTimeRange(fetchData.time_range);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {

        setHasCalculated(false);
    }, [activeButton, selectedTypeEnglish, weight, volume, check1, check2, quantityPack, PackWeight, PackVolume, totalVolume, check6, check7]);

    useEffect(() => {
        if (activeButton && selectedTypeEnglish && weight && volume) {
            const index = buttons.findIndex(button => button.value === activeButton);
            const calculatedWeight = check1 ? weight : check2 ? (quantityPack * PackWeight) : weight;
            const calculateVolume = check1 ? volume : check2 && check6 ? PackVolume * quantityPack : check2 && check7 ? totalVolume : volume;

            Calculate(
                deliviry_type_translater[index + 1],
                selectedTypeEnglish,
                calculatedWeight,
                calculateVolume
            );
        }
    }, [activeButton, selectedTypeEnglish, weight, volume, check1, check2, quantityPack, PackWeight, PackVolume, totalVolume, check6, check7]);



    // сбор данных груза
    const Data = () => {
        const deliveryType = buttons.find(button => button.value === activeButton)?.label || 'Неизвестный тип доставки';

        const Invoice = {
            "name": fullName,
            "phone": phoneNumber,
            "email": email,
            "company_name": companyName,
            "weight": check1 ? weight : check2 ? (quantityPack * PackWeight) : weight,
            "volume": check1 ? volume : check2 && check6 ? PackVolume * quantityPack : check2 && check7 ? totalVolume : volume,
            "delivery_type": activeButton,
            "cargo_type": selectedTypeEnglish,
            "country_from": selectedCities[0],
            "country_to": selectedCities[1],
            "calc_option_type": CalcOptions,
            "calc_option_unit": unit,
            "similar_package": similarPackage,
            "packages": packages,
            "product_code": codeProduct,
            "invoice_cost": invoicePrice != '' ? parseInt(invoicePrice) : 0,
            "deal_condition": dealCondition,
            "services": {
                "custom_clearance": selectedServicesEn,
                "selection_by": selectedSuppliersEn,
                "payment_methods": selectedPaymentEn
            },
            "palletes": onPalets ? true : false,
            "palletes_count": palets,
            "palletes_stackable": stackable,
            "palletes_type": typePalets,
            "delivery_to_door": adress,
            "delivery_time": timeRange,
            "delivery_cost": cost
        };
        localStorage.setItem('Invoice', JSON.stringify(Invoice));
        const invoiceData = localStorage.getItem('Invoice');
        const invoice = JSON.parse(invoiceData);
        console.log(invoice);


    };

    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const sendInvoice = async () => {
        const invoiceData = localStorage.getItem('Invoice');
        if (!invoiceData) {
            console.log('Нет данных для отправки.');
            return;
        }

        const invoice = JSON.parse(invoiceData);
        setErrorMessage(''); // Сбрасываем сообщение об ошибке

        try {
            const url = !authorized ? `${BACKEND_URL}/api/v1/profile/orders/unauthorized` : `${BACKEND_URL}/api/v1/profile/orders`
            if (authorized) {
                delete invoice["name"];
                delete invoice["phone"];
                delete invoice["email"];
                delete invoice["company_name"];
            }
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(invoice),
            });

            // Обработка ответа
            if (response.ok) {
                const result = await response.json();
                console.log('Данные успешно отправлены:', result);
                navigate('/primary');
            } else {
                if (response.status === 400) {
                    setErrorMessage('Заполните все поля.');
                } else if (response.status === 409) {
                    setErrorMessage('Пользователь уже существует.');
                } else {
                    setErrorMessage('Произошла ошибка при отправке данных.');
                }
            }
        } catch (error) {
            console.error('Ошибка:', error);
            setErrorMessage('Произошла ошибка при отправке данных.');
        }
    };

    useEffect(() => {
        Data();
    }, [weight, volume, density, activeButton, selectedCities, selectedTypeEnglish, unit, CalcOptions, similarPackage, packages, codeProduct, invoicePrice, dealCondition, selectedServices, selectedSuppliers, selectedPayment, adress, palets, stackable, typePalets, onPalets, fullName, email, phoneNumber, companyName, cost, time, selectedServicesEn, selectedSuppliersEn, selectedPaymentEn]);



    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BACKEND_URL}/api/v1/block/main/data`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const fetchData = await response.json();
                setData(fetchData);
                console.log(fetchData)
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const [isMenuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };
    return (

        <div className='bg-[#EFF0F2] h-[100%] w-[100%]'>


            {
                data.map((block) => {
                    switch (block.type) {
                        case "main":
                            return (
                                <>
                                    <MobileNav
                                        authorized={authorized}
                                        setAuthorized={setAuthorized}
                                        data={block.payload}
                                        isOpen={isMenuOpen}
                                        toggleMenu={toggleMenu} />
                                    <SlidingMenu
                                        authorized={authorized}
                                        setAuthorized={setAuthorized}
                                        data={block.payload}
                                        isOpen={isMenuOpen}
                                        onClose={toggleMenu}
                                    />
                                    <NavBar
                                        logo={block.payload.logo[1]}
                                        color={block.payload.colors[0].colorBlack}
                                        burger={block.payload.burgerRed[0]}
                                        data={block.payload}
                                        authorized={authorized}
                                        toggleMenu={toggleMenu}
                                    />
                                </>
                            )
                    }
                })
            }







            <div className={`w-full h-full lg:p-4 bg-[#EFF0F2] ${Tnved ? 'hidden' : 'block'}`}>

                <div className='flex items-center gap-[5px] p-[20px] text-[14px]'>
                    <a href='/'>Главная</a>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.47406 3.53125L10.9455 8.00265L6.47406 12.4741L5.53125 11.5312L9.05985 8.00265L5.53125 4.47406L6.47406 3.53125Z" fill="#4B535B" />
                    </svg>
                    <p>Калькулятор</p>
                </div>

                <div className='max-w-[900px] bg-white rounded-3xl flex-col flex mx-auto'>
                    <div className='flex mx-auto flex-row items-center justify-between p-4 w-full lg:w-[86%]'>
                        <img className='min-w-[32px] w-[7%]' src={PAGE === 1 ? './calkNavigator/str1Active.svg' : './calkNavigator/str1.svg'} />
                        <img className='w-[20%]' src={PAGE === 1 ? './calkNavigator/polosaPolufull.svg' : './calkNavigator/polosaFull.svg'} />

                        <img className='min-w-[32px] w-[7%]' src={PAGE === 2 ? './calkNavigator/str2Active.svg' : PAGE > 2 ? './calkNavigator/str2.svg' : './calkNavigator/str2Non.svg'} />
                        <img className='w-[20%]' src={PAGE === 2 ? './calkNavigator/polosaPolufull.svg' : PAGE > 2 ? './calkNavigator/polosaFull.svg' : './calkNavigator/polosaNon.svg'} />

                        <img className='min-w-[32px] w-[7%]' src={PAGE === 3 ? './calkNavigator/str3Active.svg' : PAGE > 3 ? './calkNavigator/str3.svg' : './calkNavigator/str3Non.svg'} />
                        <img className='w-[20%]' src={PAGE === 3 ? './calkNavigator/polosaPolufull.svg' : PAGE > 3 ? './calkNavigator/polosaFull.svg' : './calkNavigator/polosaNon.svg'} />

                        <img className='min-w-[32px] w-[7%]' src='./calkNavigator/str4.svg' />


                    </div>

                    <div className='hidden lg:flex flex-row mx-auto items-center justify-between px-4 w-full pb-4'>
                        <div className='flex flex-col items-center w-[173px]'>
                            <span className='text-[#626C75]'>Шаг 1</span>
                            <span>Маршрут и параметры</span>
                        </div>

                        <div className='flex flex-col items-center w-[173px]'>
                            <span className='text-[#626C75]'>Шаг 2</span>
                            <span>Условия поставки</span>
                        </div>

                        <div className='flex flex-col items-center w-[173px]'>
                            <span className='text-[#626C75]'>Шаг 3</span>
                            <span>Услуги</span>
                        </div>

                        <div className='flex flex-col items-center w-[173px]'>
                            <span className='text-[#626C75]'>Шаг 4</span>
                            <span>Итоговая стоимость</span>
                        </div>
                    </div>

                    <div className='block lg:hidden pl-[25px]'>
                        <div className='text-[#626C75] text-[14px]'>
                            Шаг {PAGE === 1 ? '1' : PAGE === 2 ? '2' : PAGE === 3 ? '3' : PAGE === 4 ? '4' : null}
                        </div>
                        <div className='font-medium'>
                            {PAGE === 1 ? 'Маршрут и параметры' : PAGE === 2 ? 'Условия поставки' : PAGE === 3 ? 'Услуги' : PAGE === 4 ? 'Итоговая стоимость' : null}
                        </div>
                    </div>

                    <hr className='hidden lg:block' />

                    {PAGE == 1 && <div className='w-full grid grid-cols-1 lg:grid-cols-2  gap-4 p-4 min-h-screen'>
                        <div className='w-full p-2 lg:p-8 flex flex-col gap-4 ' style={{ backgroundImage: "url('./Group.png')", backgroundPosition: "left 150px", backgroundRepeat: 'no-repeat' }}>

                            <span className='text-[30px] lg:text-[40px]'>Маршрут <br /> и параметры</span>
                            <span>Укажите пункты отправления и назначения, а также вес и объём доставляемого груза</span>

                        </div>

                        <div className='w-full flex flex-col'> {/* Добавлено overflow-hidden */}
                            <span className='text-[24px] my-2'>Маршрут</span>
                            <div className="rounded-[16px] border-[#C9CED2] border-[1px] bg-[#fff] flex items-center w-full p-[16px] sm:p-[20px] gap-[12px] mb-[10px] relative"> {/* Добавлено relative */}
                                <div className='flex flex-col items-center'>
                                    <img src="/img/calkulator/otkuda.svg" />
                                    <img src="/img/calkulator/punktir.svg" />
                                    <img src="/img/calkulator/kuda.svg" />
                                </div>
                                <div className="w-full">
                                    {/* Откуда нада */}
                                    <button onClick={() => toggleDropdown(0)} className="w-full flex items-center justify-between">
                                        <div>{selectedCities[0] || 'Выберите город'}</div>
                                        <div>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="#626C75" />
                                            </svg>
                                        </div>
                                    </button>

                                    {/* Выпадающий список для первой страны */}
                                    {openDropdownIndex === 0 && (
                                        <div className="absolute right-[30px] sm:right-[60px] w-[270px] sm:w-[444px] bg-white border rounded-[26px] border-gray-300 shadow-lg z-30 p-[26px]">
                                            <div className='flex justify-between'>
                                                <div className='flex items-center gap-[5px]'>
                                                    <img src="/img/calkulator/otkuda.svg" />
                                                    <span>Откуда</span>
                                                </div>
                                                <button onClick={() => setOpenDropdownIndex(null)}>
                                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <path d="M16.1793 5.50078L15.0008 4.32227L10.0008 9.32227L5.00078 4.32227L3.82227 5.50078L8.82227 10.5008L3.82227 15.5008L5.00078 16.6793L10.0008 11.6793L15.0008 16.6793L16.1793 15.5008L11.1793 10.5008L16.1793 5.50078Z" fill="#626C75" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className='filters my-[20px] flex gap-[5px] flex-wrap'>
                                                <button
                                                    onClick={() => selectCountry('Все', 0)}
                                                    className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[0] === 'Все' ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                                    Все
                                                </button>
                                                {countries.map((country) => (
                                                    <button
                                                        key={country}
                                                        onClick={() => selectCountry(country, 0)}
                                                        className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[0] === country ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                                        {country}
                                                    </button>
                                                ))}
                                            </div>
                                            <div className='cities overflow-y-auto h-[200px] custom-scroll'>
                                                {(showAllCities[0] || selectedCountries[0] === 'Все' ? Object.values(cities).flat() : cities[selectedCountries[0]] || []).map((city) => (
                                                    <div key={city} onClick={() => selectCity(city, 0)} className="p-2 hover:bg-gray-200 cursor-pointer">
                                                        {city}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Кнопка для смены стран */}
                                    <div className="flex items-center justify-center relative">
                                        <div className="absolute inset-x-0 border-solid border-[1px] border-[#E4E6E9]"></div>
                                        <button onClick={swapCountries} className="bg-[#fff] group hover:bg-[#C3372E] transition-colors border-solid border-[1px] border-[#C9CED2] ml-[60%] rounded-[100px] p-[5px] z-10 flex items-center">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className='fill-[#1F2225] transition-colors group-hover:fill-[#fff]'>
                                                <path d="M12.7587 8.01536L7.99949 2.46289L3.24023 8.01536L4.75875 9.31694L6.99949 6.70274L6.99949 20.9995H8.99949L8.99949 6.70274L11.2402 9.31694L12.7587 8.01536Z" />
                                                <path d="M21.7587 15.9836L16.9995 21.5361L12.2402 15.9836L13.7587 14.682L15.9995 17.2962L15.9995 2.99948L17.9995 2.99948L17.9995 17.2962L20.2402 14.682L21.7587 15.9836Z" />
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Куда нада */}
                                    <button onClick={() => toggleDropdown(1)} className="w-full flex items-center justify-between">
                                        <div>{selectedCities[1] || 'Выберите город'}</div>
                                        <div>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="#626C75" />
                                            </svg>
                                        </div>
                                    </button>

                                    {/* Выпадающий список для второй страны */}
                                    {openDropdownIndex === 1 && (
                                        <div className="absolute bg-white border border-gray-300 mt-[-50px] right-[30px] sm:right-[60px] w-[270px] sm:w-[444px] rounded-[26px] shadow-lg z-30 p-[26px]">
                                            <div className='flex justify-between'>
                                                <div className='flex items-center gap-[5px]'>
                                                    <img src="/img/calkulator/kuda.svg" />
                                                    <span>Куда</span>
                                                </div>
                                                <button onClick={() => setOpenDropdownIndex(null)}>
                                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <path d="M16.1793 5.50078L15.0008 4.32227L10.0008 9.32227L5.00078 4.32227L3.82227 5.50078L8.82227 10.5008L3.82227 15.5008L5.00078 16.6793L10.0008 11.6793L15.0008 16.6793L16.1793 15.5008L11.1793 10.5008L16.1793 5.50078Z" fill="#626C75" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className='filters my-[20px] flex gap-[5px] flex-wrap'>
                                                <button
                                                    onClick={() => selectCountry('Все', 1)}
                                                    className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[1] === 'Все' ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                                    Все
                                                </button>
                                                {countries.map((country) => (
                                                    <button
                                                        key={country}
                                                        onClick={() => selectCountry(country, 1)}
                                                        className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[1] === country ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                                        {country}
                                                    </button>
                                                ))}
                                            </div>
                                            <div className='cities overflow-y-auto h-[200px] custom-scroll'>
                                                {(showAllCities[1] || selectedCountries[1] === 'Все' ? Object.values(cities).flat() : cities[selectedCountries[1]] || []).map((city) => (
                                                    <div key={city} onClick={() => selectCity(city, 1)} className="p-2 hover:bg-gray-200 cursor-pointer">
                                                        {city}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <span className='text-[#626C75] my-2 text-[17px]'>Способ</span>

                            <div className='flex items-center mb-4 flex-wrap gap-[8px]'>
                                {buttons.map((button, index) => (
                                    <div key={index} className="relative">
                                        <input
                                            type="radio"
                                            id={`button-${index}`}
                                            name="transport"
                                            value={button.value}
                                            checked={activeButton === button.value}
                                            onChange={() => setActiveButton(button.value)}
                                            className="absolute opacity-0"
                                        />
                                        <label
                                            htmlFor={`button-${index}`}
                                            className={`cursor-pointer border border-solid border-1px border-[#C9CED2] rounded-[50px] flex items-center gap-[4px] py-[6px] px-[12px] text-[14px] sm:text-[16px]
                    ${activeButton === button.value ? 'bg-[#1F2225] text-white' : 'bg-[#fff] text-[#C9CED2]'}
                    hover:bg-[#1F2225] hover:text-white transition duration-200`}
                                            onMouseEnter={() => setHoveredButton(index)}
                                            onMouseLeave={() => setHoveredButton(null)}
                                        >
                                            <img
                                                src={hoveredButton === index || activeButton === button.value ? button.activeImg : button.greyImg}
                                                alt={button.label}
                                            />
                                            {button.label}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div className='p-[12px] sm:py-[15px] sm:px-[20px] border-[1px] border-solid border-[#C9CED2] rounded-[16px] w-full mt-[10px]'>
                                {!selectedType ? (
                                    <>
                                        <a className='w-full cursor-pointer' onClick={handleToggle}>
                                            <div className='flex justify-between items-center'>
                                                <div className='text-[#626C75]'>
                                                    <div className='text-[14px]'>Тип груза</div>
                                                    <div className='text-[18px] sm:text-[20px]'>Выберите из списка</div>
                                                </div>
                                                <div>
                                                    <svg
                                                        width="20"
                                                        height="21"
                                                        viewBox="0 0 20 21"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                                                    >
                                                        <path d="M15.5887 8.58867L9.99941 14.1779L4.41016 8.58867L5.58867 7.41016L9.99941 11.8209L14.4102 7.41016L15.5887 8.58867Z" fill="#626C75" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </a>
                                        <div className={`flex items-center flex-wrap gap-[8px] transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-[16px]' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                                            {cargoTypes.map((type, index) => (
                                                <div key={type} className="relative my-[10px]">
                                                    <input
                                                        type="radio"
                                                        id={`cargo-type-${index}`}
                                                        name="cargoType"
                                                        value={type}
                                                        checked={selectedType === type}
                                                        onChange={() => handleSelectType(type)}
                                                        className="absolute opacity-0"
                                                    />
                                                    <label
                                                        htmlFor={`cargo-type-${index}`}
                                                        className='py-[6px] px-[13px] text-[#1F2225] bg-[#EFF0F2] text-[14px] rounded-[50px] cursor-pointer hover:text-[#fff] hover:bg-[#1F2225] duration-200'
                                                    >
                                                        {type}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className='flex justify-between items-center'>
                                        <div className='text-[#626C75]'>
                                            <div className='text-[14px] text-[#fff] bg-[#1F2225] rounded-[50px] py-[6px] px-[12px]'>{selectedType}</div>
                                        </div>
                                        <button onClick={handleReset}>
                                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.1793 11.4992L12.0008 12.6777L7.00078 7.67773L2.00078 12.6777L0.822266 11.4992L5.82227 6.49922L0.822266 1.49922L2.00078 0.320712L7.00078 5.32071L12.0008 0.320712L13.1793 1.49922L8.17929 6.49922L13.1793 11.4992Z" fill="#1F2225" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>

                            <span className='text-[24px] my-3'>Параметры груза</span>
                            <div className='flex flex-row gap-2 items-center'>
                                <span className='text-[#626C75] text-[17px]'>Варианты расчета</span>
                                <img style={{ aspectRatio: 1 }} onClick={clickAlBl} className='cursor-pointer w-[24px] h-[24px]' src='./info-def.png' />
                            </div>
                            <div className=''>
                                <CargoParams
                                    check1={check1}
                                    check2={check2}
                                    setCheck1={setCheck1}
                                    setCheck2={setCheck2}
                                    check3={check3}
                                    setCheck3={setCheck3}
                                    check4={check4}
                                    setCheck4={setCheck4}
                                    check5={check5}
                                    setCheck5={setCheck5}
                                    check6={check6}
                                    check7={check7}
                                    setCheck6={setCheck6}
                                    setCheck7={setCheck7}
                                    title1={'кг/груз'}
                                    title2={'кг/упаковка'}
                                    handleDensityInputChange={handleDensityInputChange}
                                    handleWeightChange={handleWeightChange}
                                    handleVolumeChange={handleVolumeChange}
                                    density={density}
                                    weight={weight}
                                    volume={volume}
                                    unit={unit}
                                    setUnit={setUnit}
                                    setCalcOptions={setCalcOptions}
                                    setSimilarPackage={setSimilarPackage}
                                    setPackages={setPackages}
                                    quantityPack={quantityPack}
                                    setQuantityPack={setQuantityPack}
                                    setPackWeight={setPackWeight}
                                    PackWeight={PackWeight}
                                    PackWidth={PackWidth}
                                    setPackWidth={setPackWidth}
                                    PackHeight={PackHeight}
                                    setPackHeight={setPackHeight}
                                    PackLength={PackLength}
                                    setPackLength={setPackLength}
                                    PackVolume={PackVolume}
                                    setPackVolume={setPackVolume}
                                    PackDensity={PackDensity}
                                    setPackDensity={setPackDensity}
                                    setTotalVolume={setTotalVolume}
                                    totalDensity={totalDensity}
                                    setTotalDensity={setTotalDensity}
                                    alBl={alBl}
                                    clickAlBl={clickAlBl}
                                    handleWeightInputChange={handleWeightInputChange}
                                />
                            </div>
                            <span className='text-[24px] my-4'>Информация о грузе</span>

                            <div className={`py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                                <div className='flex flex-col'>
                                    <span className='text-[14px] text-[#626C75]'>Код товара</span>
                                    <input
                                        type="text"
                                        value={codeProduct}
                                        onChange={handleInputChangeCode} // Обработчик изменений
                                        placeholder="Введите код товара" // Подсказка для пользователя
                                    />
                                </div>
                                <button className={`rounded-full text-[14px]  py-1 px-2 text-white bg-[#C3372E] hover:bg-[#E0473F] cursor-pointer`}
                                    onClick={() => TnvedOpen()}>Подобрать</button>
                            </div>

                            <AlertBlock title={'Вы можете найти товар по коду из базы'} />

                            <div className={`py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px] bg-white`}>
                                <div className='flex flex-col w-full'>
                                    <div className='w-full flex flex-row justify-between'>
                                        <span className='text-[14px] text-[#626C75]'>Стоимость по инвойсу</span>
                                        <span className='text-[14px] text-[#626C75]'>$</span>
                                    </div>
                                    <input
                                        className='w-full'
                                        type="text"
                                        value={invoicePrice}
                                        onChange={handleInputChangePrice} // Обработчик изменений
                                        placeholder="Введите стоимость" // Подсказка для пользователя
                                    />
                                </div>
                            </div>

                            <div className='mt-[24px] flex justify-between items-center'>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Сроки доставки</div>
                                    <div className='text-[#626C75] text-[20px]'><span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>{time}</span> дн.</div>
                                </div>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Стоимость</div>
                                    <div className='text-[#626C75] text-[20px]'>от <span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>${cost}</span></div>
                                </div>
                            </div>

                            <div className='mt-[24px]'>
                                <button onClick={() => SET_PAGE(PAGE + 1)} className='w-full bg-[#C3372E] text-[#fff] text-[16px] sm:text-[20px] font-medium flex justify-between items-center py-[14px] px-[20px] sm:py-[20px] sm:px-[32px] rounded-[65px] hover:bg-[#E0473F] duration-200'>
                                    Продолжить расчёт
                                    <img src="/img/calkulator/strelkaBtn.svg" />
                                </button>
                            </div>
                        </div>


                    </div>}

                    {PAGE == 2 && <div className='w-full grid grid-cols-1 lg:grid-cols-2 p-4 min-h-screen'>
                        <div className='w-full p-2 lg:p-8 flex flex-col gap-4' style={{ backgroundImage: "url('./Group.png')", backgroundPosition: "left 150px", backgroundRepeat: 'no-repeat' }}>

                            <span className='text-[30px] lg:text-[40px]'>Условия поставки</span>
                            <span className='text-[14px] md:text-[16px]'>Укажите пункты отправления и назначения, а также вес и объём доставляемого груза</span>

                            <div className='mb-[40px]'>
                                <button className='flex items-center gap-[7px] px-[20px] py-[12px] bg-none rounded-[30px] border-[1px] border-solid duration-300'
                                    style={{
                                        background: 'none',
                                        borderColor: '#1F2225'
                                    }}
                                    onClick={() => SET_PAGE(PAGE - 1)}>
                                    <img src='./Arrow_left.svg' />
                                    Вернуться назад
                                </button>
                            </div>
                        </div>

                        <div className='w-full flex gap-3 flex-col lg:pt-8'>

                            <Condition setDealCondition={setDealCondition} />


                            <div className='mt-[24px] flex justify-between items-center'>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Сроки доставки</div>
                                    <div className='text-[#626C75] text-[20px]'><span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>{time}</span> дн.</div>
                                </div>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Стоимость</div>
                                    <div className='text-[#626C75] text-[20px]'>от <span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>${cost}</span></div>
                                </div>
                            </div>



                            <div className='mt-[24px]'>
                                <button onClick={() => SET_PAGE(PAGE + 1)} className='w-full bg-[#C3372E] text-[#fff] text-[16px] sm:text-[20px] font-medium flex justify-between items-center py-[14px] px-[20px] sm:py-[20px] sm:px-[32px] rounded-[65px] hover:bg-[#E0473F] duration-200'>
                                    Продолжить расчёт
                                    <img src="/img/calkulator/strelkaBtn.svg" />
                                </button>
                            </div>
                        </div>

                    </div>}

                    {PAGE == 3 && <div className='w-full grid grid-cols-1 lg:grid-cols-2 p-4 min-h-screen'>
                        <div className='w-full p-2 lg:p-8 flex flex-col gap-4' style={{ backgroundImage: "url('./Group.png')", backgroundPosition: "left 150px", backgroundRepeat: 'no-repeat' }}>

                            <span className='text-[30px] lg:text-[40px]'>Услуги</span>
                            <span>Укажите необходимые при оформлении услуги. Будь то хранение на складе или доп.упаковка</span>

                            <div>
                                <button className='flex items-center gap-[7px] px-[20px] py-[12px] bg-none rounded-[30px] border-[1px] border-solid duration-300'
                                    style={{
                                        background: 'none',
                                        borderColor: '#1F2225'
                                    }}
                                    onClick={() => SET_PAGE(PAGE - 1)}>
                                    <img src='./Arrow_left.svg' />
                                    Вернуться назад
                                </button>
                            </div>

                        </div>

                        <div className='w-full flex gap-3 flex-col'>

                            <SetCheckBox
                                title={"Услуги таможенного оформления"}
                                btns={["Таможенное декларирование", "Сертификация товара", "Честный знак"]}
                                all={"Выбрать все"}
                                del={"Отменить все"}
                                onSelectionChange={handleServicesSelectionChange}
                            />
                            <SetCheckBox
                                title={"Подбор поставщика и товара"}
                                btns={["Поиск товара по фото или ссылке", "Подбор и переговоры с поставщиком"]}
                                all={"Выбрать все"}
                                del={"Отменить все"}
                                onSelectionChange={handleSuppliersSelectionChange}
                            />
                            <SetCheckBox
                                title={"Оплата счёта за товар"}
                                btns={["Оплата со счёта компании", "Оплата наличными"]}
                                all={"Выбрать все"}
                                del={"Отменить все"}
                                onSelectionChange={handlePaymentSelectionChange}
                            />

                            <span className='text-[24px] my-2'>Доставка до двери</span>

                            <div className={`py-2 px-4 w-full flex justify-between items-center flex-row rounded-2xl border-[1px]`}>
                                <div className='flex flex-col'>
                                    <span className='text-[14px] text-[#626C75]'>Адрес</span>
                                    <input
                                        type="text"
                                        placeholder='Адрес'
                                        value={adress}
                                        onChange={handleAddressInputChange}
                                    />
                                </div>
                                <span className={`rounded-full text-[14px]  py-1 px-2`}></span>
                            </div>


                            <OnPalets
                                onPalets={onPalets}
                                setOnPalets={setOnPalets}
                                palets={palets}
                                handlePaletsInputChange={handlePaletsInputChange}
                                handlePaletsChange={handlePaletsChange}
                                setStackable={setStackable}
                                setStackableText={setStackableText}
                                typePalets={typePalets}
                                setTypePalets={setTypePalets}
                            />

                            <div className='mt-[24px] flex justify-between items-center'>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Сроки доставки</div>
                                    <div className='text-[#626C75] text-[20px]'><span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>{time}</span> дн.</div>
                                </div>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Стоимость</div>
                                    <div className='text-[#626C75] text-[20px]'>от <span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>${cost}</span></div>
                                </div>
                            </div>
                            <div className='mt-[24px]'>
                                <button onClick={() => SET_PAGE(PAGE + 1)} className='w-full bg-[#C3372E] text-[#fff] text-[16px] sm:text-[20px] font-medium flex justify-between items-center py-[14px] px-[20px] sm:py-[20px] sm:px-[32px] rounded-[65px] hover:bg-[#E0473F] duration-200'>
                                    Продолжить расчёт
                                    <img src="/img/calkulator/strelkaBtn.svg" />
                                </button>
                            </div>
                        </div>

                    </div>}

                    {PAGE == 4 && <div className='w-full grid grid-cols-1 lg:grid-cols-2 p-4 min-h-screen'>
                        <div className='w-full p-2 lg:p-8 flex flex-col gap-4' style={{ backgroundImage: "url('./Group.png')", backgroundPosition: "left 150px", backgroundRepeat: 'no-repeat' }}>

                            <span className='text-[30px] lg:text-[40px]'>Итоговый расчет</span>
                            <span>Укажите пункты отправления и назначения, а также вес и объём доставляемого груза</span>

                            <div className='mb-[40px]'>
                                <button className='flex items-center gap-[7px] px-[20px] py-[12px] bg-none rounded-[30px] border-[1px] border-solid duration-300'
                                    style={{
                                        background: 'none',
                                        borderColor: '#1F2225'
                                    }}
                                    onClick={() => SET_PAGE(PAGE - 1)}>
                                    <img src='./Arrow_left.svg' />
                                    Вернуться назад
                                </button>
                            </div>
                        </div>

                        <div className='w-full flex gap-3 flex-col lg:pt-8'>

                            { !authorized && 
                            <div className=''>

                                <div className='text-[24px] mb-[24px]'>Личные данные</div>

                                <div className='flex flex-col gap-[10px] mb-[20px]'>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>ФИО</div>
                                        <div className='text-[16px]'>
                                            <input
                                                className='w-[270px]'
                                                type="text"
                                                value={fullName}
                                                onChange={handleInputChange(setFullName)}
                                                placeholder="Введите ФИО"
                                            />
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>Название компании</div>
                                        <div className='text-[16px]'>
                                            <input
                                                className='w-[270px]'
                                                type="text"
                                                value={companyName}
                                                onChange={handleInputChange(setCompanyName)}
                                                placeholder="Введите название компании"
                                            />
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>Почта</div>
                                        <div className='text-[16px]'>
                                            <input
                                                className='w-[270px]'
                                                type="email"
                                                value={email}
                                                onChange={handleInputChange(setEmail)}
                                                placeholder="Введите почту"
                                            />
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>Номер телефона</div>
                                        <div className='text-[16px]'>
                                            <input
                                                className='w-[270px]'
                                                type="tel"
                                                value={phoneNumber}
                                                onChange={handleInputChange(setPhoneNumber)}
                                                placeholder="Введите номер телефона"
                                            />
                                        </div>
                                    </div>
                                </div>




                                <div className='text-[24px] mb-[24px]'>Маршрут и параметры</div>
                                <div className='flex flex-col sm:flex-row sm:items-center gap-[8px] mb-[20px]'>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full sm:w-[70%]'>
                                        <div className='text-[14px] text-[#626C75]'>
                                            Маршрут
                                        </div>
                                        <div className=' flex items-center gap-[8px]'>
                                            <span>{selectedCities[0]}</span>
                                            <div className='w-[24px] h-[24px] flex items-center justify-center bg-[#C3372E] rounded-[100px]'>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.80213 3.53125L14.2735 8.00265L9.80213 12.4741L8.85932 11.5312L11.7213 8.66932H3.33073C2.96254 8.66932 2.66406 8.37084 2.66406 8.00265C2.66406 7.63446 2.96254 7.33599 3.33073 7.33599H11.7213L8.85932 4.47406L9.80213 3.53125Z" fill="white" />
                                                </svg>
                                            </div>
                                            <span>{selectedCities[1]}</span>
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-fill sm:w-[29%]'>
                                        <div className='text-[14px] text-[#626C75]'>
                                            Способ
                                        </div>
                                        <div className='flex items-center gap-[8px]'>
                                            <div className='w-[24px] h-[24px] p-[2px] flex items-center justify-center bg-[#1F2225] rounded-[100px]'>
                                                <img src={deliveryImage} />
                                            </div>
                                            {deliveryText}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex items-center flex-wrap gap-[8px]'>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full sm:w-[49%]'>
                                        <div className='text-[14px] text-[#626C75] flex items-center justify-between'>
                                            <div>Кол-во упаковок</div>
                                            <div>шт.</div>
                                        </div>
                                        <div>
                                            {check1 ? 1 : quantityPack}
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full sm:w-[49%]'>
                                        <div className='text-[14px] text-[#626C75] flex items-center justify-between'>
                                            <div>Общий вес</div>
                                            <div>кг.</div>
                                        </div>
                                        <div>
                                            {check1 ? weight : check2 ? (quantityPack * PackWeight) : weight}
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full sm:w-[49%]'>
                                        <div className='text-[14px] text-[#626C75] flex items-center justify-between'>
                                            <div>Объем</div>
                                            <div>м.куб.</div>
                                        </div>
                                        <div>
                                            {check1 ? volume : check2 && check6 ? PackVolume * quantityPack : check2 && check7 ? totalVolume : volume}
                                        </div>
                                    </div>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full sm:w-[49%]'>
                                        <div className='text-[14px] text-[#626C75] flex items-center justify-between'>
                                            <div>Плотность</div>
                                            <div>кг/м.куб.</div>
                                        </div>
                                        <div>
                                            {check1 ? density : check2 && check6 ? ((quantityPack * PackWeight) / (PackVolume * quantityPack)).toFixed(2) : check2 && check7 ? ((quantityPack * PackWeight) / totalVolume).toFixed(2) : density}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }

                            <div>
                                <div className='text-[24px] mb-[24px] mt-[40px]'>Условия поставки</div>
                                <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                    <div className='text-[14px] text-[#626C75]'>
                                        Оформление контракта
                                    </div>
                                    <div className='text-[20px]'>
                                        {dealCondition || 'Не выбранно'}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='text-[24px] mb-[24px] mt-[40px]'>Услуги</div>

                                <div className='flex flex-col gap-[8px]'>
                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75] mb-[12px]'>
                                            Услуги таможенного оформления
                                        </div>
                                        <div className='flex items-center flex-wrap gap-[4px]'>
                                            {
                                                selectedServices.length > 0 && selectedServices.map((service, index) => (
                                                    <div key={index} className='px-[12px] py-[6px] bg-[#EFF0F2] rounded-[43px]'>
                                                        {service}
                                                    </div>
                                                ))
                                            }
                                            {
                                                selectedServices.length === 0 && (
                                                    <div className='px-[12px] py-[6px] bg-[#FFDDDD] rounded-[43px]'>
                                                        Не выбранно
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75] mb-[12px]'>
                                            Подбор поставщика и товара
                                        </div>
                                        <div className='flex items-center flex-wrap gap-[4px]'>
                                            {
                                                selectedSuppliers.length > 0 && selectedSuppliers.map((service, index) => (
                                                    <div key={index} className='px-[12px] py-[6px] bg-[#EFF0F2] rounded-[43px]'>
                                                        {service}
                                                    </div>
                                                ))
                                            }
                                            {
                                                selectedSuppliers.length === 0 && (
                                                    <div className='px-[12px] py-[6px] bg-[#FFDDDD] rounded-[43px]'>
                                                        Не выбранно
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75] mb-[12px]'>
                                            Оплата счёта за товар
                                        </div>
                                        <div className='flex items-center flex-wrap gap-[4px]'>
                                            {
                                                selectedPayment.length > 0 && selectedPayment.map((service, index) => (
                                                    <div key={index} className='px-[12px] py-[6px] bg-[#EFF0F2] rounded-[43px]'>
                                                        {service}
                                                    </div>
                                                ))
                                            }
                                            {
                                                selectedPayment.length === 0 && (
                                                    <div className='px-[12px] py-[6px] bg-[#FFDDDD] rounded-[43px]'>
                                                        Не выбранно
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>
                                            Доставка до двери
                                        </div>
                                        <div className='text-[20px]'>
                                            {adress || 'Не выбранно'}
                                        </div>
                                    </div>

                                    <div className='border-[1px] border-solid border-[#C9CED2] p-[14px] rounded-[16px] w-full'>
                                        <div className='text-[14px] text-[#626C75]'>
                                            Палеты
                                        </div>
                                        <div className='text-[20px]'>
                                            {
                                                onPalets ?
                                                    `${palets}, ${stackableText}`
                                                    :
                                                    'Нет'
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>



                            <div className='my-[24px] flex justify-between items-center'>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Сроки доставки</div>
                                    <div className='text-[#626C75] text-[20px]'><span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>{time}</span> дн.</div>
                                </div>
                                <div>
                                    <div className='text-[#626C75] text-[14px] mb-[12px]'>Стоимость</div>
                                    <div className='text-[#626C75] text-[20px]'>от <span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>${cost}</span></div>
                                </div>
                            </div>
                            <div className='text-[#C3372E]'>{errorMessage}</div>
                            <div className=''>
                                <button onClick={sendInvoice} className='w-full bg-[#C3372E] text-[#fff] text-[16px] sm:text-[20px] font-medium flex justify-between items-center py-[14px] px-[20px] sm:py-[20px] sm:px-[32px] rounded-[65px] hover:bg-[#E0473F] duration-200'>
                                    Продолжить расчёт
                                    <img src="/img/calkulator/strelkaBtn.svg" />
                                </button>
                            </div>

                        </div>

                    </div>}


                </div>

            </div>
            <div className={`h-[100%] w-[100%]  ${Tnved ? 'block' : 'hidden'}`}>
                <TnVed TnvedOpen={TnvedOpen} Tnved={Tnved} />
            </div>


        </div>
    );
};

export default Calculator;
